import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useLang } from "@/i18n";
import { ProgereVersionBadge } from "@/progere-design-system/ProgereVersionBadge";

// Pied de page légal universel PROGÈRE (tokens --pg-*).
export function ProgereLegalFooter({ inApp = false, showVersion = false }) {
  const navigate = useNavigate();
  const { lang } = useLang();
  const isEn = lang === "en";
  const [entity, setEntity] = useState(null);
  useEffect(() => { api.get("/legal/entity").then((r) => setEntity(r.data)).catch(() => {}); }, []);

  const company = entity?.company || "Groupe MJR Construction Inc.";
  const neq = entity?.neq && !entity.neq.includes("compléter") ? entity.neq : null;
  const year = new Date().getFullYear();

  const links = [
    { to: "/confidentialite", label: isEn ? "Privacy (Law 25)" : "Confidentialité (Loi 25)" },
    { to: "/conditions", label: isEn ? "Terms" : "Conditions d'utilisation" },
    { to: "/temoins", label: isEn ? "Cookies" : "Témoins" },
    { to: "/responsabilite", label: isEn ? "Liability" : "Responsabilité" },
  ];

  return (
    <footer className={`${inApp ? "mt-8 pt-6" : "py-8"}`} style={{ borderTop: "1px solid var(--pg-border)" }} data-testid="legal-footer">
      <div className={`${inApp ? "" : "max-w-6xl mx-auto px-6"}`}>
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
          <div className="text-xs" style={{ color: "var(--pg-text-muted)" }}>
            <span>PROGÈRE CRM — {isEn ? "PROGÈRE ERP ecosystem" : "écosystème PROGÈRE ERP"} · © {year} {company}</span>
            {neq && <span> · NEQ {neq}</span>}
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5">
            {links.map((l) => (
              <button key={l.to} onClick={() => navigate(l.to)} data-testid={`footer-link-${l.to.slice(1)}`}
                className="text-xs transition-colors hover:opacity-80" style={{ color: "var(--pg-text-secondary)" }}>
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mt-3">
          <span className="text-xs" style={{ color: "var(--pg-text-muted)" }}>
            {isEn ? "Powered by" : "Propulsé par"} <span className="font-semibold" style={{ color: "var(--pg-gold)" }}>{company}</span>
          </span>
          {showVersion && <ProgereVersionBadge />}
        </div>
      </div>
    </footer>
  );
}
